import styled, { css } from 'styled-components';

export const Wrapper = styled.section`
  min-height: 400px;
  padding: 24px;
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    color: ${theme.palette.grey.dark};
    font-size: ${theme.font.sizes.lg};
    font-weight: ${theme.font.weights.regular};
    margin: 0 0 24px 0;
  `}
`;

export const Description = styled.div``;

export const AttentionCancelSignatureLabel = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;

    strong{
      font-weight: ${theme.v2.font.weights.bold} !important;
    }    
  `}
`;

export const AttentionCancelExclusionLabel = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 4px 0 0 0;

    strong{
      font-weight: ${theme.v2.font.weights.bold} !important;
    }    
  `}
`;

export const ListWrapper = styled.div`
  margin: 8px 0;
`;

export const ListTitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0 0 8px 0;
  `}
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ListItem = styled.li`
  ${({ theme }) => css`
    position: relative;
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    padding: 0;
    list-style: disc;
    margin-left: 26px;

    strong{
      font-weight: ${theme.v2.font.weights.bold} !important;
    }
  `}
`;

export const SupportFormsWrapperVPSOciCancel = styled.div`
  ${({ theme }) => css`
    margin: 48px 0 0 0;

    @media (max-width: ${theme.breakpoints.md}) {
      margin: 32px 0 0 0;
    }

    > div{
      padding-left: 0;

      > div{
        padding: 0;
      }
    }
  `}    
`;
